import { Consultation } from "../../../calendar/model";
import DayRow from "./DayRow";
import { WeekType } from "./modal";
import { useSelector } from "../../../store/store";
import {
    getDailyConsultations,
    isDayDisabled,
    isDayEmpty,
} from "../../../store/data";
import { useTranslation } from "react-i18next";

interface RegularDay {
    isRegular: true;
    index: number;
    name: string;
    weekType: WeekType;
    year?: never;
    dateString?: never;
    week?: never;
}

export interface IndividualDay {
    isRegular: false;
    index: number;
    name: string;
    weekType: WeekType;
    year: number;
    dateString: string;
    week: number;
}

export type DayProps = RegularDay | IndividualDay;

interface Props {
    day: DayProps;
}
export const defaultConsultation: Consultation = {
    start: "06:00",
    end: "20:00",
    room_id: "-1",
    specialization_id: [],
};

const Day = ({ day }: Props) => {
    const dailyConsultations = useSelector(getDailyConsultations(day));
    const empty = useSelector(isDayEmpty(day));
    const dayDisabled = useSelector(isDayDisabled(day));
    const { t } = useTranslation();

    return (
        <div
            style={{
                opacity: dayDisabled ? 0.7 : 1,
            }}
        >
            {empty ? (
                <DayRow
                    consultation={{ ...defaultConsultation, index: 0 }}
                    day={day}
                    additional={false}
                />
            ) : (
                dailyConsultations.map((consultation, index) => (
                    <DayRow
                        key={index}
                        consultation={{ ...consultation, index }}
                        day={day}
                        additional={index !== 0}
                    />
                ))
            )}
        </div>
    );
};

export default Day;
